<template>
  <div class="settlement-wait-detail-head">
    <div class="b-2-f0 p-20 flex-ac flex-h-sb">
      <span class="f-14 c-3">
        补退状态：
        <span>{{ data.allowPayStatus | convertStatus }}</span>
      </span>
      <div>
        <!-- <el-button size="mini" type="primary" plain @click="exportDetail">导出结算明细</el-button> -->
        <div v-if="showOperateButton()">
          <el-button plain="" size="small" type="primary" @click="handleOperateClick">{{
            convertOperateText()
          }}</el-button>
        </div>
      </div>
    </div>
    <div class="b-2-f0 p-20 m-t20 f-14 c-3">
      <el-row>
        <el-col :span="8">采购方：{{ data.buyerOrgName }}</el-col>
      </el-row>
      <el-row class="m-t15">
        <el-col :span="6">订单号：{{ data.bizOrderId }}</el-col>
        <el-col :span="6">订单状态：{{ data.orderStatus | orderStatusFormat }}</el-col>
        <el-col :span="6"
          >下单人：{{ data.buyerNick }}
          <i class="el-icon-s-comment c-hover f-16" @click="showIM(data.buyerId)"></i>
        </el-col>
        <el-col :span="6">订单创建时间：{{ data.orderGmtCreated | parseTime }}</el-col>
      </el-row>
      <el-row class="m-t15">
        <el-col :span="6">订单金额：{{ data.orderAmount | currencyFormat }}</el-col>
        <el-col :span="6">买家已付款金额：{{ data.paidAmount | currencyFormat }}</el-col>
        <el-col :span="6">订单已结算金额：{{ data.settledAmount | currencyFormat }}</el-col>
        <el-col :span="6"
          >补退金额：
          <span v-if="data.amount === 0 || data.allowPayStatus === 2">--</span>
          <span v-else>
            {{ data.amountDirection === 1 ? '待补款' : '待退款' }}
            <span class="c-hover">{{ Math.abs(data.amount) | currencyFormat }}</span>
          </span>
        </el-col>
      </el-row>
    </div>
    <refund-dialog
      :visible.sync="refundVisible"
      :data="refundData"
      @refresh="$emit('refresh')"
    ></refund-dialog>
    <supplement-dialog
      :visible.sync="supplementVisible"
      :data="supplementData"
      @refresh="$emit('refresh')"
    ></supplement-dialog>
  </div>
</template>

<script>
import { download } from '@/common/utils/download'
import preview from '@/common/utils/preview'
import RefundDialog from './refund-dialog'
import SupplementDialog from './supplement-dialog'

const text_supplement = '确认收到补款'
const text_refund = '去退款'
const text_see_refund = '查看退款凭证'

export default {
  name: 'WaitDetailHead',
  components: { RefundDialog, SupplementDialog },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      refundVisible: false,
      refundData: {
        bizOrderId: '',
        accountPayId: '',
        buyerOrgId: '',
        buyerOrgName: '',
        amount: '',
        isPreview: false
      },

      supplementVisible: false,
      supplementData: {
        bizOrderId: '',
        accountPayId: '',
        buyerOrgName: ''
      }
    }
  },

  filters: {
    convertStatus(status) {
      let text = ''
      if (status === 1) {
        text = '待补退'
      } else if (status === 2) {
        text = '未完成结算，暂时无需补退'
      } else if (status === 3) {
        text = '已补退'
      }
      return text
    },
    convertStatusTag(status) {
      let text = 'color:#909399;'
      if (status === 1 || status === 2) {
        text = 'color:#F0242E;'
      } else if (status === 3) {
        text = 'color:#67c23a;'
      }
      return text
    }
  },
  methods: {
    showIM(id) {
      const obj = id ? { sessionId: id } : null
      window.IM && window.IM.show(obj)
    },
    showOperateButton() {
      const {
        amount,
        allowPayStatus,
        accountPayStatus,
        certUploadFlag,
        amountDirection
      } = this.data
      if (amount !== 0 && allowPayStatus === 1) {
        //金额不等于0并且允许支付
        if (accountPayStatus === 3 && certUploadFlag) {
          //支付中
          return true
        } else {
          //非支付中
          if (amountDirection === 2) {
            //去退款
            return true
          }
        }
      }
      return false
    },
    handleOperateClick() {
      const text = this.convertOperateText()
      if (text === text_supplement) {
        //确认补款
        this.supplementData.bizOrderId = this.data.bizOrderId
        this.supplementData.accountPayId = this.data.accountPayId
        this.supplementData.buyerOrgName = this.data.buyerOrgName
        this.supplementVisible = true
      } else {
        this.refundData.bizOrderId = this.data.bizOrderId
        this.refundData.accountPayId = this.data.accountPayId
        this.refundData.buyerOrgName = this.data.buyerOrgName
        this.refundData.buyerOrgId = this.data.buyerOrgId
        this.refundData.amount = this.data.amount
        this.refundData.isPreview = text === text_refund ? false : true
        this.refundVisible = true
      }
    },
    convertOperateText() {
      const {
        amount,
        allowPayStatus,
        accountPayStatus,
        certUploadFlag,
        amountDirection
      } = this.data
      if (amount !== 0 && allowPayStatus === 1) {
        //金额不等于0并且允许支付
        if (accountPayStatus == 3) {
          //支付中
          if (certUploadFlag) {
            //线下支付，已经上传凭证
            if (amountDirection === 1) {
              //确认收到补款
              return text_supplement
            } else {
              //查看凭证
              return text_see_refund
            }
          }
        } else {
          //非支付中
          if (amountDirection === 2) {
            //去退款
            return text_refund
          }
        }
      }
      return ''
    }
  }
}
</script>
